export default function Sass_Introspection() {
  return (
    <div>
      <h1>Sass Introspection</h1>
    </div>
  );
}
